module.exports = __webpack_public_path__ + "static/media/daycareIcon.c285bbfd.png";